import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import { GetPessoaJuridicaCnpjService, type TConta } from '@/features/proposta/services/get-pessoa-juridica-por-cnpj'
import { propostaKeys } from '@/features/proposta/utils'

export const usePessoaJuridicaPorCnpj = (cnpj: string, enabled?: boolean): UseQueryResult<TConta, AxiosError> => {
  return useQuery({
    queryKey: propostaKeys.pessoaJuridica(cnpj),
    queryFn: async () => new GetPessoaJuridicaCnpjService().execute({ cnpj }).then((res) => res.data),
    enabled,
  })
}
